<template>
  <div class="q-col-12 q-mt-5 get-the-look__container" v-if="hasProducts">
    <ComponentLoader :loading="getSliderLoading"/>
    <MainHeader :title="'Stylista AI poleca'"/>
    <div class="q-row get-the-look__row">
      <swiper
          class="swiper"
          :navigation="true"
          :modules="modules"
          :space-between="10"
          :slides-per-view="slidesPerView"
          :slides-per-group="slidesPerGroup"
          :breakpoints="breakpoints"
          :centered-slides="false"
          :autoplay="autoplayOptions"
      >

        <swiper-slide class="slide" v-for="product in getProducts" :key="product.id">
          <ProductItem :product="product"/>
        </swiper-slide>
      </swiper>
      <SeeMoreButton :title="'Zobacz wszystkie >>'"/>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'
import ComponentLoader from '../ComponentLoader.vue'
import MainHeader from '@/components/MainHeader'
import SeeMoreButton from '@/components/SeeMoreButton'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'

const modules = ref([Pagination, Navigation, Autoplay])
const autoplayOptions = {
  delay: 3500,
  disableOnInteraction: true
}

import { storeToRefs } from 'pinia'
import { useSliderStore } from '@/store/sliderStore'
import ProductItem from '@/components/StylisationSlider/ProductItem.vue'

const sliderStore = useSliderStore()

const { getProducts, hasProducts, getSliderLoading } = storeToRefs(sliderStore)

const slidesPerView = 4
const slidesPerGroup = 1

const breakpoints = {
  // X-Small devices (portrait phones, less than 576px)
  576: {
    slidesPerView: 1,
    spaceBetween: 10
  },
  // Small devices (landscape phones, 576px and up)
  768: {
    slidesPerView: 2,
    spaceBetween: 10
  },
  // Medium devices (tablets, 768px and up)
  992: {
    slidesPerView: 3,
    spaceBetween: 10
  },
  // Large devices (desktops, 992px and up)
  1200: {
    slidesPerView: 4,
    spaceBetween: 10
  },
  // X-Large devices (large desktops, 1200px and up)
  1400: {
    slidesPerView: 4,
    spaceBetween: 10
  }
}



onBeforeMount(async () => {
  await sliderStore.fetchProducts()
})

</script>
<style>
.get-the-look__gtl-group-container, .get-the-look__stylisation-container {
  min-height: 300px;
  position: relative !important;
}

.get-the-look__row {
  display: flex;
  align-items: stretch;
}

.get-the-look__stylisation-container,
.get-the-look__gtl-group-container {
  flex: 1; /* Daje obu kontenerom tę samą elastyczność */
}

.swiper-button-prev, .swiper-button-next {
  color: #000 !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #000 !important;
  background: #000 !important;
}

.swiper-button-prev:after, .swiper-button-next:after {
  padding: 20px !important;
}

</style>
